import { render, staticRenderFns } from "./editAdvert.vue?vue&type=template&id=db8ede56&scoped=true&"
import script from "./editAdvert.vue?vue&type=script&lang=js&"
export * from "./editAdvert.vue?vue&type=script&lang=js&"
import style0 from "./editAdvert.vue?vue&type=style&index=0&id=db8ede56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db8ede56",
  null
  
)

export default component.exports